// Single source of truth for the "Valkenhall is a fan project" disclaimer
// text. Rendered both during the intro splash (IntroSplash.jsx) and on the
// credits screen (CreditsScreen.jsx). Keep these in lockstep. Changing
// the wording here updates both surfaces, so we never end up with two
// subtly different legal blurbs out in the wild.
//
// Returned as JSX fragments rather than plain strings so the embedded
// <em> emphasis on the trademarked names survives. Consumers map over
// the array and wrap each entry in their own <p> with whatever class /
// style they want. That way the intro splash and credits screen can
// keep their distinct typographic chrome around shared body copy.

import { t } from '../localization/t';

const TRADEMARKS = {
  owner: "Erik's Curiosa Ltd",
  curiosa: 'Curiosa',
  sorcery: 'Sorcery: Contested Realm',
};

// Takes the translated sentence with its trademark placeholders still in
// place and fills each one with an <em>, so the emphasis survives whatever
// order the translation puts the names in.
function emphasizeTrademarks(text) {
  return text.split(/(\{\w+\})/).map((part) => {
    const name = TRADEMARKS[part.slice(1, -1)];
    return part.startsWith('{') && name ? <em>{name}</em> : part;
  });
}

export function fanProjectDisclaimerParagraphs() {
  return [
    (
      <>
        {t('Valkenhall is an unofficial, non-commercial fan project.')}
        {' '}
        {emphasizeTrademarks(t('It is not affiliated with, endorsed by, sponsored by, or associated with {owner}, {curiosa}, or {sorcery}.'))}
      </>
    ),
    (
      <>
        {t("All card names, artwork, game rules, and related marks are the property of Erik's Curiosa Ltd and used under nominative fair use to enable community play.")}
      </>
    ),
  ];
}

export const FAN_PROJECT_FOOTNOTE = 'Made by fans, for fans.';
